import styled from '@emotion/styled';

export const ErrorMessage = styled.p`
    color: ${({ theme }): string => theme.feature.errorColor};
    text-align: center;
`;
